import { Box, Typography } from "@mui/material";
import { WasteManifestSource } from "generated-graphql/graphql";
import { Fragment } from "react";

import { SOURCE_LABEL, SOURCE_ORDER } from "./manifestSourceDisplay";

interface SourcesDisagreeTooltipProps {
  /** Per-source display values for the field; missing/blank sources are omitted. */
  values: Partial<Record<WasteManifestSource, string | null | undefined>>;
}

/**
 * Tooltip body for the "Sources disagree on this value" warning: the message
 * plus a two-column Source / value table so the reader sees each source's
 * reported value aligned. Shared by the manifest-detail fields, the line-item
 * modal, and the line-item grid's Amount cell.
 */
export function SourcesDisagreeTooltip({ values }: SourcesDisagreeTooltipProps) {
  return (
    <Box>
      <Typography variant="caption" sx={{ display: "block", mb: 0.5 }}>
        Data sources may report different values. Encamp is reconciling them. Contact Encamp Support
        with questions.
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "auto 1fr",
          columnGap: 1.5,
          rowGap: 0.25,
          alignItems: "baseline",
        }}
      >
        {SOURCE_ORDER.map((source) => {
          const value = values[source];
          if (value == null || value === "") return null;
          return (
            <Fragment key={source}>
              <Typography variant="caption" sx={{ fontWeight: 600, whiteSpace: "nowrap" }}>
                {SOURCE_LABEL[source]}
              </Typography>
              <Typography variant="caption">{value}</Typography>
            </Fragment>
          );
        })}
      </Box>
    </Box>
  );
}
